import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.#mask)
    this.element.addEventListener("keydown", this.#preventInvalid)
  }

  disconnect() {
    this.element.removeEventListener("input", this.#mask)
    this.element.removeEventListener("keydown", this.#preventInvalid)
  }

  #mask = (event) => {
    const input = event.target
    const digits = input.value.replace(/\D/g, "").slice(0, 11)
    input.value = this.#format(digits)
  }

  #preventInvalid = (event) => {
    const allowed = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"]
    if (!allowed.includes(event.key) && !/^\d$/.test(event.key)) {
      event.preventDefault()
    }
  }

  #format(digits) {
    if (digits.length === 0) return ""
    if (digits.length <= 2) return `(${digits}`
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
  }
}
